import { defaultTheme } from "../defaultTheme"
import { darkPalette } from "./dark-palette"

export const darkTheme = {
  type: "dark",
  ...defaultTheme,
  palette: darkPalette,
}
